import { useEffect, useState } from "react";
import { toast } from "sonner";
import { admin } from "../../lib/api";
import { panel, inputCls, btnPrimary, Field, PageHead } from "../ui";

export default function SettingsPage() {
  const [s, setS] = useState(null);
  useEffect(() => { admin.get("/admin/settings").then((r) => setS(r.data)); }, []);
  if (!s) return <p className="text-zinc-500">Loading…</p>;
  const set = (k, v) => setS({ ...s, [k]: v });
  const save = async () => {
    await admin.put("/admin/settings", s);
    if (s.accent_color) document.documentElement.style.setProperty("--ss-accent", s.accent_color);
    toast.success("Settings saved");
  };

  return (
    <div>
      <PageHead title="Settings"><button onClick={save} className={btnPrimary} data-testid="settings-save-btn">Save</button></PageHead>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <div className={`${panel} p-5 space-y-4`}>
          <p className="text-sm font-semibold text-white uppercase tracking-wider">Brand</p>
          <Field label="Store name"><input className={inputCls} value={s.store_name || ""} onChange={(e) => set("store_name", e.target.value)} /></Field>
          <Field label="Tagline"><input className={inputCls} value={s.tagline || ""} onChange={(e) => set("tagline", e.target.value)} /></Field>
          <Field label="Logo URL"><input className={inputCls} value={s.logo_url || ""} onChange={(e) => set("logo_url", e.target.value)} /></Field>
          <div className="grid grid-cols-2 gap-3 items-end">
            <Field label="Accent colour"><div className="flex gap-2"><input type="color" value={s.accent_color || "#2563EB"} onChange={(e) => set("accent_color", e.target.value)} className="w-12 h-10 bg-transparent" /><input className={inputCls} value={s.accent_color || ""} onChange={(e) => set("accent_color", e.target.value)} data-testid="accent-color" /></div></Field>
            <Field label="Packaging theme">
              <select className={inputCls} value={s.packaging_theme || "blue"} onChange={(e) => set("packaging_theme", e.target.value)}>
                <option value="blue">Blue</option><option value="bw">Black & White</option>
              </select>
            </Field>
          </div>
        </div>

        <div className={`${panel} p-5 space-y-4`}>
          <p className="text-sm font-semibold text-white uppercase tracking-wider">Commerce</p>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Currency"><input className={inputCls} value={s.currency || "INR"} onChange={(e) => set("currency", e.target.value)} /></Field>
            <Field label="GST %"><input type="number" className={inputCls} value={s.gst_rate || 5} onChange={(e) => set("gst_rate", Number(e.target.value))} /></Field>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Free shipping over (₹)"><input type="number" className={inputCls} value={s.free_shipping_threshold || 0} onChange={(e) => set("free_shipping_threshold", Number(e.target.value))} /></Field>
            <Field label="Flat shipping (₹)"><input type="number" className={inputCls} value={s.flat_shipping_rate || 0} onChange={(e) => set("flat_shipping_rate", Number(e.target.value))} /></Field>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Field label="COD fee (₹)"><input type="number" className={inputCls} value={s.cod_fee || 0} onChange={(e) => set("cod_fee", Number(e.target.value))} /></Field>
            <Field label="COD max order (₹)"><input type="number" className={inputCls} value={s.cod_max || 0} onChange={(e) => set("cod_max", Number(e.target.value))} /></Field>
          </div>
          <label className="flex items-center gap-2 text-sm text-zinc-300"><input type="checkbox" checked={s.cod_enabled !== false} onChange={(e) => set("cod_enabled", e.target.checked)} data-testid="cod-toggle" /> Cash on Delivery enabled</label>
          <label className="flex items-center gap-2 text-sm text-zinc-300"><input type="checkbox" checked={s.emails_enabled !== false} onChange={(e) => set("emails_enabled", e.target.checked)} data-testid="emails-toggle" /> Transactional emails enabled</label>
          <label className="flex items-center gap-2 text-sm text-zinc-300"><input type="checkbox" checked={!!s.maintenance_mode} onChange={(e) => set("maintenance_mode", e.target.checked)} /> Maintenance mode</label>
        </div>
      </div>
    </div>
  );
}
